
import React from "react";
import SEO from "../shared/SEO";
import logo from '../../src/assets/logo.png'
import imageRight from '../../assets/imageright.png'
import image1 from '../../assets/image-left-1.png'
import image2 from '../../assets/image-left-2.png'
import image3 from '../../assets/image-left-3.png'
import Navbar from "./Navbar";
import Footer from "./Footer";
import { useNavigate } from "react-router-dom";

export default function StartupStudio() {
  const navigate = useNavigate()
  return (
    <div className="bg-white">
      <SEO
        title="Startup Studio | Branding, Product and Execution"
        description="From branding to product development, Orcas Valley Startup Studio helps founders build and launch with expert execution."
        url="https://orcasvalley.web.app/startup-studio"
        keywords="startup studio, product development, branding services, startup execution, development kitchen, startup services"
      />
           <Navbar />    {/* Hero Section */}
    <header className="relative text-white h-[85vh] flex flex-col sm:flex-row items-center justify-center sm:justify-start p-6 sm:p-10">
  {/* Background Image */}
  <div className="absolute inset-0 px-6 md:px-10 py-2 md:py-0">
    <div
      className="w-full h-full bg-cover bg-center rounded-lg"
      style={{ backgroundImage: "url('/Rectangle 1-bg.png')" }} // Update the image path accordingly
    ></div>
  </div>

  {/* Content Container */}
  <div className="relative text-center sm:text-left px-6 sm:px-20 mt-24 sm:mt-40">
    <h1 className="text-4xl sm:text-6xl font-medium leading-tight">
      Startup Studio: Branding, Product <br className="hidden sm:block" /> and Execution
    </h1>
    <p className="mt-4 text-base sm:text-lg font-light max-w-xs sm:max-w-lg mx-auto sm:mx-0">
      From branding to product development, Orcas Valley Startup Studio helps founders build and launch with expert execution, development kitchen, and branding services.
    </p>

    {/* Buttons */}
    <div className="mt-6 flex flex-col sm:flex-row items-center space-y-3 sm:space-y-0 sm:space-x-3">
      {/* Talk to Us Button */}
      <button
        onClick={() => navigate('/auth')} 
      className="px-6 py-2 bg-white hover:bg-[#2CFFCC] text-black rounded-full font-light flex items-center space-x-2 shadow-md w-full sm:w-auto">
        <span>Talk to Us</span>
        <span className="text-lg">→</span>
      </button>
    </div>
  </div>

  {/* Side Text (Vertical) - Hidden on Mobile */}
  <div className="absolute top-6 left-3 xs:left-2 sm:top-10 sm:left-6 md:left-10 z-20 px-5 flex flex-col items-center text-gray-300 text-lg tracking-widest sm:flex">
    <div className="border-l-2 border-gray-300 h-6 sm:h-10 mb-1 sm:mb-2"></div>
    <p className="flex flex-col text-center text-xs">
    <span>T</span>
      <span>H</span>
      <span>E</span>
      <br />
      <span>O</span>
      <span>R</span>
      <span>C</span>
      <span>A</span>
      <span>S</span>
      <br />
      <span>W</span>
      <span>A</span>
      <span>Y</span>
    </p>
  </div>
</header>



{/* Development Kitchen Section */}
<section className="w-full px-6 mt-16 mb-5 md:mb-16 flex flex-col md:flex-row items-center justify-between">
  {/* Left Side - Text Content */}
  <div className="w-full md:w-1/2 text-center md:text-left mb-10 md:mb-0 md:pl-12">
    <h2 className="text-3xl sm:text-4xl text-gray-700 font-light">
      Startup Development<br />
      <span className="text-[#02C4A1]">Kitchen</span>
    </h2>
    <p className="mt-4 text-gray-600 leading-relaxed">
      Our startup development kitchen combines<br className="hidden sm:block" />
      seasoned designers and developers that<br className="hidden sm:block" />
      will work with founders to develop unique<br className="hidden sm:block" />
      product development and branding solutions<br className="hidden sm:block" />
      tailored to your startup business needs.
    </p>
  </div>

  {/* Right Side - Image */}
  <div className="w-full md:w-1/2 flex justify-center md:justify-start">
    <img
      src={imageRight}
      alt="Development Kitchen Visual"
      className="w-[90%] sm:w-[80%] md:w-[90%] max-w-[500px] h-auto object-contain rounded-lg"
    />
  </div>
</section>


<section className="max-w-6xl mx-auto px-6 flex flex-col-reverse md:flex-row  items-center mt-20 xs:mt-20 md:mt-20  lg:mt-16">
  {/* Left Side - Images */}
  <div className="w-full sm:w-1/2 flex flex-col space-y-6 py-10 items-center ">
    <img src={image1} alt="Step 1" className="w-[70%] sm:w-[50%] h-auto self-start" />
    <img src={image2} alt="Step 2" className="w-[70%] sm:w-[50%] h-auto self-center" />
    <img src={image3} alt="Step 3" className="w-[70%] sm:w-[50%] h-auto self-start" />
  </div>

  {/* Right Side - Branding Info */}
  <div className="w-full  sm:w-1/2 text-center sm:text-left mb-4 sm:mb-0 mt-10">
    <h2 className="text-3xl text-[#02C4A1] font-light">Startup Branding Services</h2>
    <p className="mt-4 font-light text-gray-600">
      Our expert branding team and copywriters offer startup founders the opportunity to build a distinguished 
      brand identity including packaging, logo creation, visual assets, marketing, and branding services.
    </p>
  </div>
</section>





    

      {/* Footer */}
      <Footer />
    </div>
  );
}
